/**
 * Component to display employees that lists Focus users
 */
import * as React from 'react';
import { IcommonProps } from './common/props';
import { Card, Row, Col, Button, Breadcrumb, Modal, Icon, Dropdown, Menu, message } from 'antd';
import Util from './common/utils';
import  auth from './common/auth';
import Print from './common/print';
import Export from './common/export';
import { MSGDISPLAYTIME } from './common/constants';
import service from '../service/apolloclient.service';
import Comparator from './common/comparer';
import EmployeeList  from './employee/EmployeeList';
import Employee  from './employee/EmployeeFilter';
import EmployeeAddEdit  from './employee/EmployeeAddEdit';
import '../css/User.scss';
import { Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { staticProperties, STATICKEYS }  from './common/staticProperties';
import { VIEWSTATE } from './common/constants';
import EmployeeBulkUpload from './employee/EmployeeBulkUpload';
import LocalStorage from '../service/localstorage';
// import { historyNotifier } from './common/historyNotifier';
import strings from '../eyeguide-localization/employee/strings.employee';
import UnAuthorized from './errorPages/unauthorized';
import Auth from './common/auth';
import { Tasks } from './common/auth';
import Token from './common/token';

const storage = new LocalStorage();
const VIEWS = {
    USERLIST: 'list',
    ADDUSER: '/employee/add',
    EDITUSER: '/employee/edit/',
    BULKUPLOAD: '/employee/upload'
};

const LISTDROPDOWNTEXT = {
    0: strings.lsInactiveTxt,
    1: strings.lsActiveTxt,
    2: strings.lsAllTxt
};

interface IemployeesProps extends IcommonProps {
    navigateFrom: any;
    location: any;
}

interface IemployeesState {
    origEmployees: any;
    employees: any;
    error: boolean;
    view: string;
    employeesAddEditTitile: string;
    breadCrumbValue: string;
    userToEdit: any;
    userToView: any;
    modalVisible: boolean;
    filterObj: any;
    prevFilterObj: any;
    disableAdd: boolean;
    showUserList: any;
    printModalVisible: boolean;
    exportModalVisisble: boolean;
    printTestOpt: number;
    navigationFrom: number;
    userBtnText: string;
    listActiveBit: number;
    orgsToFilter: any;
    emptyText: string;
    loading: boolean;
    isFocusUser: boolean;
    canViewEmployee: boolean;
}

export default class Employees extends React.Component<IemployeesProps, IemployeesState> {
    iframe: HTMLIFrameElement | null;
    menu = (
        <Menu onClick={() => this.exportFile()}>
          <Menu.Item key="1">CSV</Menu.Item>
        </Menu>
    );
    
    constructor(props: IemployeesProps) {
        super(props);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.state = {
            origEmployees: [],
            error : false,
            employees: [],
            view: VIEWS.USERLIST,
            employeesAddEditTitile: strings.lsManageEmpTxt,
            breadCrumbValue: strings.lsManageEmpTxt,
            userToEdit: '',
            modalVisible: false,
            filterObj: [],
            prevFilterObj: [],
            userToView: '',
            disableAdd: true,
            showUserList: true,
            printModalVisible: false,
            exportModalVisisble: false,
            printTestOpt: 0,
            navigationFrom: 0,
            userBtnText: LISTDROPDOWNTEXT['1'],
            listActiveBit: 1,
            orgsToFilter: [],
            loading: true,
            emptyText: '',
            isFocusUser: Auth.canPerformTask(roleid, Tasks.isFocusUser),
            canViewEmployee: Auth.canPerformTask(roleid, Tasks.canViewEmployee)
          };
        this.changeFilter = this.changeFilter.bind(this);
        this.handleUserActivation = this.handleUserActivation.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
    }

    componentDidMount() {
        // console.log('history', this.props.location.state);
        if (storage.getSelectedOrgName() !== '') {
            this.logoutFromOrg();
        }
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.EMPLOYEE);
        staticProperties.set(STATICKEYS.selectedRoster, '');
        // this.logoutFromOrg();
        Util.resetScroll();
        if (!this.ifRouteExists(this.props)) {

            this.intializeUserList(this.state.listActiveBit);
            // this.props.enableTitleSpace(true);
        }
    }
 
    componentWillReceiveProps(nextProps: any) {
        Util.resetScroll();
        if (!this.ifRouteExists(nextProps)) {
            staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.EMPLOYEE);
            staticProperties.set(STATICKEYS.selectedRoster, '');
            this.intializeUserList(this.state.listActiveBit);
            this.setState({view: VIEWS.USERLIST,                      
                breadCrumbValue: strings.lsManageEmpTxt, 
                employeesAddEditTitile: strings.lsManageEmpTxt, 
                userToEdit: '',
            });
        }
    }

    render() {
        if (!this.state.isFocusUser || !this.state.canViewEmployee) {
            return (
                <UnAuthorized/>
            );
        } else {
        return (
            <div>
            <Route
                path={VIEWS.EDITUSER + ':userid'} 
                render={(props: any) => 
                    <EmployeeAddEdit
                        save=""
                        cancel=""
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        organizationID={this.props.organizationID} 
                        rosterID=""
                        navigationFrom={this.state.navigationFrom}
                        {...props}
                    />                 
                }
            />
            <Route
                path={VIEWS.ADDUSER} 
                render={(props: any) => 
                    <EmployeeAddEdit
                        save=""
                        cancel=""
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        organizationID={this.props.organizationID} 
                        rosterID=""
                        navigationFrom={this.state.navigationFrom}
                        {...props}
                    />                 
                }
            />
                <Route
                    path={VIEWS.BULKUPLOAD} 
                    render={(props: any) => 
                    <EmployeeBulkUpload
                        {...props}
                    />
                }
                />
            { this.ifRouteExists(this.props) ? '' :
                <div className="User">
                <Card >
                    <Breadcrumb>
                        <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item>{strings.lsEmpTxt}</Breadcrumb.Item>
                    </Breadcrumb>
                        <br/>
                    <h3>{this.state.employeesAddEditTitile} </h3>
                </Card>
                <div className="contentWithoutTitle">
                    <Card className="filterCard">
                        <span 
                            className="filterIcon"
                            onClick={e => {
                                console.log('clicked');
                                this.setState({
                                    modalVisible: true
                                });
                                }}
                        >
                        <Icon 
                            type="filter" 
                            style={{fontSize: 19, float: 'right'}}
                        />
                        </span>
                        <span style={{'fontSize': '14px', 'fontWeight': 'normal'}}>
                            <span hidden={this.checkIfFilterExists('', true)}>
                               {strings.lsNoFilterTxt}
                            </span>
                            <div className="filterContent" hidden={!this.checkIfFilterExists('', true)}>
                                <Button 
                                    className="clearFilter" 
                                    onClick={e => {
                                        this.clearFilters();
                                    }}
                                >
                                    {strings.lsClearFiltersTxt}
                                </Button>
                                <Row className="filterRow" hidden={this.checkIfFilterExists('username')}>
                                    <Col span={5}>{strings.lsUsrNameTxt}:</Col> 
                                    <Col span={15}> {this.getFilterValues('username')} </Col>
                                </Row>
                                <Row className="filterRow" hidden={this.checkIfFilterExists('firstname')}>
                                    <Col span={5}>{strings.lsFNameTxt}:</Col>
                                    <Col span={15}>{this.getFilterValues('firstname')}</Col>
                                </Row>
                                <Row className="filterRow" hidden={this.checkIfFilterExists('lastname')}>
                                    <Col span={5}>{strings.lsLNameTxt}:</Col>
                                    <Col span={15}>{this.getFilterValues('lastname')} </Col>
                                </Row>
                                <Row className="filterRow" hidden={this.checkIfFilterExists('email')}>
                                    <Col span={5}>{strings.lsEmailTxt}:</Col>
                                    <Col span={15}>{this.getFilterValues('email')}</Col>
                                </Row>
                                <Row className="filterRow" hidden={this.checkIfFilterExists('role')}>
                                    <Col span={5}>{strings.lsRoleTxt}:</Col>
                                    <Col span={15}>{this.getFilterValues('role')}</Col>
                                </Row>
                            </div>
                        </span>

                    </Card>                   
                    <Card 
                        title={strings.lsManageEmpTxt}
                        bordered={false}
                        className="card"
                    >
                    <Link
                        to={VIEWS.ADDUSER}
                    >
                        <Button         
                            type="primary" 
                            icon="plus-circle-o"
                        >{strings.lsAddEmpTxt}
                        </Button>   
                    </Link>
                    <Link 
                        style={{color: 'white', paddingLeft: '5px'}}
                        to={VIEWS.BULKUPLOAD}
                    >
                        <Button         
                            type="primary" 
                            icon="upload"
                        >
                            {strings.lsUploadEmpTxt}
                        </Button>
                    </Link>
                        <Dropdown 
                            trigger={['click']}
                            overlay={this.menu}
                            getPopupContainer={this.getContainer}
                        ><Button className="downloadBtn"> 
                            {strings.lsDwnldTxt} <Icon type="down" style={{ fontSize: 10}}/> </Button>
                        </Dropdown>
                        <Modal
                            title={strings.lsExportUsrTxt}
                            visible={this.state.exportModalVisisble}
                            onOk={() => this.setState({exportModalVisisble: false})}
                            okText={strings.lsOkTxt}
                            width={450}
                            bodyStyle={{padding: 0 }}
                            maskClosable={false}
                            closable={false}
                            footer={[
                                <Button 
                                        key="Ok" 
                                        type="primary"  
                                        onClick={() => this.setState({exportModalVisisble: false})}
                                >
                                {strings.lsOkTxt}
                                </Button>,
                            ]}
                        >
                        <Row style={{padding: '19px'}}>
                            {strings.lsExportEmpSuccessTxt}
                        </Row>
                        </Modal>
                        <Button 
                            style={{marginLeft: 10, marginBottom: 20, float: 'right'}}
                            onClick={() => this.printList()}
                        >{strings.lsPrintTxt}
                        </Button>           
                        <iframe 
                            style={{height: 0, width: 0, border: 'none'}} 
                            ref={el => this.iframe = el} 
                        /> 
                        <Dropdown 
                            trigger={['click']}
                            overlay={
                                <Menu  onClick={(e: any) => this.changeListDisplay(e)}>
                                    <Menu.Item key="0">
                                    {LISTDROPDOWNTEXT['0']}
                                    {this.state.listActiveBit === 0 ?
                                        <Icon 
                                            type="check" 
                                            style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}}
                                        />
                                                    : ''}
                                    </Menu.Item>
                                    <Menu.Item key="1">{LISTDROPDOWNTEXT['1']}
                                    {this.state.listActiveBit === 1 ?
                                        <Icon 
                                            type="check" 
                                            style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}} 
                                        /> 
                                                    : ''}
                                    </Menu.Item>
                                    <Menu.Item key="2">{LISTDROPDOWNTEXT['2']}
                                    {this.state.listActiveBit === 2 ?
                                        <Icon 
                                            type="check" 
                                            style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}} 
                                        /> 
                                                    : ''}
                                    </Menu.Item>
                                </Menu>}
                            getPopupContainer={this.getContainer}
                        >   
                            <Button className="downloadBtn"> 
                                {this.state.userBtnText} 
                                <Icon type="down" style={{ fontSize: 10, paddingRight: '7px'}}/> 
                            </Button>
                        </Dropdown>
                        <EmployeeList
                            organizationID={this.props.organizationID} 
                            rosterID={this.props.rosterID} 
                            organizationName={this.props.organizationName}
                            enableTitleSpace={this.props.enableTitleSpace}
                            users={this.state.employees}
                            notifyActiveClick={this.handleUserActivation}
                            notifyResetClick={this.resetPassword}
                            loading={this.state.loading}
                            emptyText={this.state.emptyText}
                        />                      
                    </Card>
                </div>
                <Modal 
                    className="modal"
                    title={strings.lsEmpFilterTxt}
                    visible={this.state.modalVisible}
                    okText={strings.lsFilterTxt}
                    onOk={() => this.setModalVisible(1)}
                    onCancel={() => this.setModalVisible(0)}
                    width={1000}
                    bodyStyle={{padding: 0 }}
                    maskClosable={false}
                    closable={false}
                    destroyOnClose={true}
                >   
                    <Employee 
                        filterObj={this.state.filterObj}
                        notifyChangeFilter={this.changeFilter}
                        orgs={this.state.orgsToFilter}
                    />                       
                </Modal>

            </div>
            }
            </div>
            
        );
    }
    }

    /**
     * Fetches the list of users from server
     */
    private async  intializeUserList(activeBit: number = 0) {
        let users: any;
        let ser = new service();
        users = await ser.getEmployees(activeBit);
        console.log('users', users);
        this.setState({
            origEmployees : users,
            employees: users,
            orgsToFilter: [],
            loading: false,
            emptyText: users.length === 0 ? 'No data' : ''
        });
        this.filterList();
    }

    /**
     * Logs out from Logged in organization.
     */
    private logoutFromOrg() {
        storage.setSelectedOrg('');      storage.setSelectedOrg('');
        storage.setSelectedOrgName('');
        storage.setSelectedOrgPrimary('');
        window.location.href = '/dashboard' ;
    }

    /**
     * Checks if any filter exists or for a particular property
     * @param property Filter property
     * @param chkIfFiltered If true, checks if any filter exists at all. 
     * If false, property is checked for existence
     */
    private checkIfFilterExists(property: string, chkIfFiltered: boolean = false): boolean {
        if (chkIfFiltered) {
            console.log('isObjectEmpty', Util.isObjectEmpty(this.state.filterObj));
            return Util.isObjectEmpty(this.state.filterObj) === true ? false : true;
        } else if (Util.isObjectEmpty(this.state.filterObj) === false) {
            console.log('isObjectEmptyElse', Util.isObjectEmpty(this.state.filterObj));
            let value = this.getFilterValues(property);
            if (value === '' || value === undefined) { return true; } else { return false; }
        } else {
            return true;
        }
    }

    /**
     * Builds print data and calls export util
     */
    private async printList() {
        console.log('usersFromPrint', this.state.employees);
        let buildData: any;
        buildData = this.buildUserData(this.state.employees);
        if (buildData.length > 0) {
            Print.printContents(buildData, strings.lsEmpTxt, this.iframe);
        }
    }

    /**
     * Clears filter array which is used fo displaying and filtering data
     */
    private clearFilters() {
        this.intializeUserList(this.state.listActiveBit);
        this.setState({
            filterObj: [],
            prevFilterObj: []
        });
    }

    /**
     * Builds export data and calls export util
     */
    private async exportFile() {
        console.log('usersForPrint', this.state.employees);
        let buildData: any;
        buildData = this.buildUserData(this.state.employees);
        if (buildData.length > 0) {
            Export.exportCSVFile(buildData, strings.lsEmpTxt);
            this.setState({exportModalVisisble: true});
        }
    }

    /**
     * Gets the value of property for which filter is applied
     * @param key Property for which filter is to be applied
     */
    private getFilterValues(key: string): string {
        // return this.state.prevFilterObj[key];  
        if (this.state.prevFilterObj[key] instanceof Array) {
            let values = this.state.prevFilterObj[key];
            let valString: any = '';
            if (key === 'role' ) {
                let roleNames: string[] = [];
                console.log('values', values);
                values.forEach((element: any) => {
                    roleNames.push(Util.getRoleValue(element));
                });
                console.log('rolesname', roleNames);
                values = roleNames;
                console.log('values', values);
            }
            for (let j = 0; j < values.length; j ++) {
                j === values.length - 1 ? valString += values[j] : valString += values[j] + ', ';
            }
            return valString; 
        } else if (this.isEmpty(this.state.prevFilterObj[key])) {
            return '';
        } else {
            return this.state.prevFilterObj[key];
        }
    }

    /**
     * Closes the filter modal and performs tasks as per the event
     * @param event Cancel/ Filter click
     */
    private setModalVisible(event: number) {
        if (event === 1) {// filter click
             this.filterList();
        } else { // cancel click
            this.setState({filterObj: {...this.state.prevFilterObj}});
        }
        this.setState({
            modalVisible: false,
        });
    }

    /**
     * Filters the list using the filter object created
     */
    private filterList() {
        console.log('filterObj', this.state.filterObj);
        console.log('userlist', this.state.origEmployees);
        let filterObject = this.state.filterObj;
        let filteredUsers = this.state.origEmployees.filter(function(obj: any[]) {
            let matched = false;   
            let comp: Comparator;
            comp = new Comparator();
            matched = comp.compare(filterObject, obj);
            // console.log('comparator', matched);
            if (matched) {
                return true;
            } else {
                return false;
            }
        });
        // console.log('filteredUsers', filteredUsers);
        this.setState({employees: filteredUsers, prevFilterObj: {...this.state.filterObj}});
    }

    /**
     * This function builds the data required by the Table component to display the employees
     * @param users Users array containing the users to be dispalyed
     */
    private buildUserData(users: Array<any>) {
        let columnData: Array<any> = [];
        users.forEach( (element: any) => {
            let data = {
                username: element.username,
                firstname: element.firstname,
                lastname: element.lastname,
                email: element.email,
                role: this.getRoleValue(element.roleid) 
            };
            columnData.push(data);
        }); 
        return columnData;
    }

    /**
     * Checks if an object is empty
     * @param obj Object to check if empty
     */
    private isEmpty(obj: any): boolean {
        if (obj instanceof Object) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        } else {
            return false;
        }
    }

    /**
     * Assigns filters set through filter component
     * @param filterObj Filter Object sent by filter component
     */
    private async changeFilter(filterObj: any) {
        console.log('changeFilter', filterObj);
        this.setState({ filterObj: filterObj });
    }

    /**
     * Changes user activation as per the active bit.
     * @param activeBit Active/InActive bit to set to the user. 0 - Inactive, 1 - Active
     * @param userId User id.
     */
    private async handleUserActivation(activeBit: number, userId: string, record: any) {
        console.log('handleUserActivation', record);
        let userObj: any = {
            active: activeBit,
            username: record.username,
            role: record.role
        };
        let ser = new service();
        let userResponse: any = await ser.addeditUser(userObj, userId, '');
        console.log('userResponse', userResponse);
        let msgTerm: string = activeBit === 0 ? strings.lsDeActivatedTxt : strings.lsActivatedTxt;
        message.success(strings.formatString(strings.lsEmpActivationSuccessTxt, msgTerm), MSGDISPLAYTIME);   
        this.intializeUserList(this.state.listActiveBit); 
    }

    /**
     * Handles the change of user list when toggled between active/inactive/all
     * @param menuObj Menu Object that is clicked
     */
    private changeListDisplay(menuObj: any) {
        console.log('changeList', menuObj);
        let itemClicked: string = menuObj.key;
        this.setState({
            userBtnText: LISTDROPDOWNTEXT[menuObj.key],  
            listActiveBit:  parseInt(itemClicked, 10),
            loading: true
         });
        this.intializeUserList(parseInt(itemClicked, 10));
    }

    /**
     * sets the container element for dropdown menu
     */
    private getContainer = (triggernode) => {
        return triggernode.parentNode;
    }

    /**
     * Gets the rolename as per the role id passed
     * @param roleid Role id
     */
    private getRoleValue(roleid: number): string {
        let rolename: any = Object.keys(auth.getRoles()).filter( (value, index) => {
            if (auth.getRoles()[value] === roleid) {
                return true;
            } else { return false; }
        });
        return Util.cascadeStringCase(rolename.toString().replace(new RegExp('_', 'g'), ' ')); 
    }

    private async resetPassword(uid: string, fname: string, username: string) {
        let ser = new service();
        // let param = {firstname: fname, username: username};
        let response = await ser.resetPassword(uid, username, 'Employee');
        if (response.status === 0) { // success
            message.success(strings.lsPassResetSuccessTxt, MSGDISPLAYTIME);    
        } else {
            message.error(strings.lsPassResetFailedTxt, MSGDISPLAYTIME);    
        }
    }

    /**
     * Checks the URL hit for other internal URL s
     * @param props Component Props
     */
    private ifRouteExists(props: any) {
        let exists = false;
        [VIEWS.ADDUSER, VIEWS.EDITUSER, VIEWS.BULKUPLOAD].forEach((e: string) => {
            exists = props.location.pathname.startsWith(e) || exists;
        });
        return exists;
    }

}


// WEBPACK FOOTER //
// ./src/components/Employees.tsx